import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, RouteReuseStrategy, withRouterConfig } from '@angular/router';

import { createErrorHandler } from '@sentry/angular';

import { createAppSharedConfig, CustomRouteReuseStrategy, environment } from '@innership-app/core';

import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    ...createAppSharedConfig(false).providers,
    { provide: ErrorHandler, useValue: createErrorHandler({ logErrors: !environment.production }) },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    provideRouter(appRoutes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
  ],
};
